import {PageSearchCondition} from "../../../../types/page";
import {useCallback, useMemo, useState} from "react";
import {useFilterValues} from "../../../../hooks/list/useFilterValues";
import {FilterType, FilterValue} from "../../../../types/filter";
import {OrganShareFilterWordType, OrganShareListQueryType} from "../../../../types/organShare";
import {useListSearchParams} from "../../../../hooks/list/useListSearchParams";

export interface OrganShareFilterValues {
    searchWordTypeFilterValue: FilterValue<OrganShareFilterWordType>;
    searchWordFilterValue: FilterValue<string>;
    isCheckedFilterValue: FilterValue<boolean>
}
export function useOrganShareFilterValues() {
    const urlParams = new URLSearchParams(window.location.search);
    const urlSearchWord = urlParams.get('searchWord');
    const urlSearchWordType = urlParams.get('searchWordType');

    const [searchWordType, setSearchWordType] = useState(urlSearchWordType);
    const [searchWord, setSearchWord] = useState(urlSearchWord);
    const [isChecked, setIsChecked] = useState(false)
    const [pageInfoOnFilter, setPageInfoOnFilter] = useState<PageSearchCondition>({});

    const { listQueryType, setUrlSearchParams } = useListSearchParams<OrganShareListQueryType>();

    // 필터 영역
    const filterValueArray: FilterValue<any>[] = useMemo(
        () => [
            {
                key: "searchWordType",
                value: searchWordType,
                setter: setSearchWordType,
                defaultValue: '',
                type: FilterType.OTHER,
            },
            { key: "searchWord", value: searchWord, setter: setSearchWord, defaultValue: '', type: FilterType.STRING },
            { key: "isChecked", value: isChecked, setter: setIsChecked, defaultValue: '', type: FilterType.BOOLEAN },
        ],
        [searchWordType, searchWord, isChecked]
    );

    const { getFilterValueByKey } = useFilterValues({
        filterValueArray,
        listQueryType: listQueryType,
        setPageInfoOnFilter,
    });

    const filterValues = useMemo(
        () =>
            ({
                searchWordTypeFilterValue: getFilterValueByKey("searchWordType") as FilterValue<OrganShareFilterWordType>,
                searchWordFilterValue: getFilterValueByKey("searchWord") as FilterValue<string>,
                isCheckedFilterValue: getFilterValueByKey("isChecked") as FilterValue<boolean>,
            } as OrganShareFilterValues),
        [getFilterValueByKey]
    );

    const searchList = useCallback(
        (pageSearchCondition: PageSearchCondition, listQueryTypeParam?: OrganShareListQueryType) => {
            const param: OrganShareListQueryType = {
                searchWordType: listQueryTypeParam?.searchWordType,
                searchWord: listQueryTypeParam?.searchWord,
            };

            return () => setUrlSearchParams(param, pageSearchCondition);
        },
        [setUrlSearchParams]
    );

    return{
        pageInfoOnFilter,
        filterValues, searchList,
        listQueryType
    }
}